export enum SapheerError {
  INVALID_PASSWORD = `Invalid Password`,
  CORPORATE_ALREADY_VALIDATED = `Corporate already validated`,
  CORPORATE_NOT_FOUND = `Corporate not found`,
  CORPORATE_LINKCY_ID_CAN_BE_NOT_NULL = `Corporate linkcy id can'be not null`,
  PHONE_NUMBER_REQUIRED = `Phone number required`,
  EMAIL_CANNOT_BE_EMPTY = `Email can'not be empty`,
  EMAIL_ALREADY_EXIST = `email already exist`,
  PHONE_ALREADY_EXIST = `phone already exist`,
  OFFER_NOT_FOUND = `Offer not found`,
  INCORPORATION_ALREADY_EXIST = `Incorporation already exist`,

  ONBOARDING_NOT_FOUND = `Onboarding not found`,
  MEMBER_ID_CAN_BE_NOT_NULL = `Member id can'be not null`,
  MEMBER_NOT_FOUND = `Member not found`,
  DIRECTOR_DATE_REQUIRED = `Director appointment date is required`,
  STRIPE_PAYMENT_NOT_PAID = "Stripe payment not paid",
}
